const dayMonth = new Intl.DateTimeFormat('cs-CZ', { day: 'numeric', month: 'numeric' });
const weekday = new Intl.DateTimeFormat('cs-CZ', { weekday: 'short' });
const fullDate = new Intl.DateTimeFormat('cs-CZ', { day: 'numeric', month: 'long', year: 'numeric' });
const time = new Intl.DateTimeFormat('cs-CZ', { hour: '2-digit', minute: '2-digit' });

/** Z ISO data (RRRR-MM-DD) udělá lokální `Date` bez posunu časové zóny. */
function parseIsoDate(iso: string): Date {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(year ?? 1970, (month ?? 1) - 1, day ?? 1);
}

export function formatDayMonth(iso: string): string {
  return dayMonth.format(parseIsoDate(iso));
}

export function formatWeekday(iso: string): string {
  return weekday.format(parseIsoDate(iso)).replace('.', '');
}

export function formatFullDate(iso: string): string {
  return fullDate.format(parseIsoDate(iso));
}

export function formatTime(isoTimestamp: string): string {
  return time.format(new Date(isoTimestamp));
}

/** „dnes“ / „zítra“ / „za 5 dní“ – pro rychlou orientaci v seznamu. */
export function relativeDay(iso: string): string {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = Math.round((parseIsoDate(iso).getTime() - today.getTime()) / 86_400_000);

  if (days <= 0) return 'dnes';
  if (days === 1) return 'zítra';
  if (days < 5) return `za ${days} dny`;
  return `za ${days} dní`;
}

/** 1 přihlášený / 2 přihlášení / 5 přihlášených */
export function plural(count: number, one: string, few: string, many: string): string {
  if (count === 1) return one;
  if (count >= 2 && count <= 4) return few;
  return many;
}
